import './UserUID.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { Button, Modal } from 'react-bootstrap';
import { useState } from 'react';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { Users } from '../../pages/Users/Users';

const UserUIDComponent = ({ uid, customText = null }) => {
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  return (
    <>
      <span className={'user-uid'} onClick={() => setDetailsModalOpen(true)}>
        <code>{customText || uid}</code>
        <FontAwesomeIcon icon={faEye} size={'sm'} className={'mx-1'} />
      </span>

      <Modal className={'dark-modal'} size={'lg'} show={detailsModalOpen} onHide={() => setDetailsModalOpen(false)} scrollable>
        <Modal.Header closeButton>
          <Modal.Title>
            Dettaglio utente
            <Button
              variant={'primary'}
              size={'sm'}
              className={'ml-2'}
              onClick={() => {
                window.open(`/admin/users?uid=${uid}`, '_blank');
              }}
            >
              Apri in un'altra scheda <FontAwesomeIcon icon={faExternalLinkAlt} className={'ml-1'} />
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Users iframe={true} initQuery={uid} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export { UserUIDComponent as UserUID };
